module.exports = __webpack_public_path__ + "static/media/bxgy-1.92a8238a.png";